module.exports = __webpack_public_path__ + "img/notificationMenuIcon.dc263ad4.svg";